import { render, staticRenderFns } from "./AddKadaster.vue?vue&type=template&id=1c83b1b4&"
import script from "./AddKadaster.vue?vue&type=script&lang=js&"
export * from "./AddKadaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports